import React from 'react';

export const TransportationPageSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {/* Header skeleton */}
      <div className="flex justify-between items-center">
        <div className="h-8 w-64 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="h-10 w-32 bg-gray-200 rounded-lg animate-pulse"></div>
      </div>

      {/* Table skeleton */}
      <div className="bg-white rounded-lg overflow-hidden shadow-sm">
        {/* Table header */}
        <div className="p-4 border-b border-gray-100">
          <div className="grid grid-cols-7 gap-4">
            {[...Array(7)].map((_, i) => (
              <div
                key={i}
                className="h-6 bg-gray-200 rounded-md animate-pulse"
                style={{
                  width: i === 0 ? '70%' : '90%',
                  animationDelay: `${i * 0.05}s`,
                }}
              ></div>
            ))}
          </div>
        </div>

        {/* Table rows */}
        {[...Array(5)].map((_, rowIndex) => (
          <div key={rowIndex} className="border-b border-gray-100 p-4">
            <div className="grid grid-cols-7 gap-4">
              {[...Array(7)].map((_, colIndex) => (
                <div
                  key={colIndex}
                  className="h-6 bg-gray-200 rounded-md animate-pulse"
                  style={{
                    width: `${60 + ((rowIndex + colIndex) % 4) * 10}%`,
                    animationDelay: `${rowIndex * 0.05 + colIndex * 0.01}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
